import { get } from 'lodash'
import { GetFormattedAgenda } from 'pages/UserDetail/components/tabs/types'

export const formatAgendaTooltip = (agenda: GetFormattedAgenda) => {
  if (!agenda) return ''

  const revisionNumber = get(agenda.metadata, 'revisionNumber', '')
  const parserRevisionNumber = revisionNumber !== '' ? `${revisionNumber}` : ''

  if (agenda.type === 'evento') {
    return agenda.title
  }

  if (
    agenda.metadata &&
    agenda.type === 'primeiro-contato' &&
    agenda.font === 'estudo-pendente'
  ) {
    return `Primeiro Contato ${agenda.metadata.field} ${
      agenda?.themes && agenda?.themes?.length > 0
        ? `- Tema: ${agenda?.themes?.map(theme => theme.name).join(', ')}`
        : ''
    } ${
      agenda?.subjects && agenda?.subjects.length > 0
        ? `- Subtema: ${agenda.subjects
            ?.map(subjects => subjects.name)
            .join(', ')}`
        : ''
    }`
  }

  if (
    agenda.metadata &&
    agenda.type === 'primeiro-contato' &&
    agenda.font === 'estudo-diario'
  ) {
    return `Revisão (#${parserRevisionNumber}) ${agenda.metadata.field} ${
      agenda?.themes && agenda?.themes?.length > 0
        ? `- Tema: ${agenda?.themes?.map(theme => theme.name).join(', ')}`
        : ''
    } ${
      agenda?.subjects && agenda?.subjects.length > 0
        ? `- Subtema: ${agenda.subjects
            ?.map(subjects => subjects.name)
            .join(', ')}`
        : ''
    }`
  }

  if (agenda.metadata && agenda.type === 'estudo-teorico') {
    return `Estudo Teórico ${agenda.metadata.field} ${
      agenda?.themes && agenda?.themes?.length > 0
        ? `- Tema: ${agenda?.themes?.map(theme => theme.name).join(', ')}`
        : ''
    } ${
      agenda?.subjects && agenda?.subjects.length > 0
        ? `- Subtema: ${agenda.subjects
            ?.map(subjects => subjects.name)
            .join(', ')}`
        : ''
    }`
  }

  if (
    agenda.metadata &&
    agenda.font === 'projeto-x' &&
    agenda.type !== 'primeiro-contato'
  ) {
    return `Revisão X (#${parserRevisionNumber}) ${
      agenda.metadata.field ? `- Área: ${agenda.metadata.field}` : ''
    } ${
      agenda?.themes && agenda?.themes?.length > 0
        ? `- Tema: ${agenda?.themes?.map(theme => theme.name).join(', ')}`
        : ''
    } ${
      agenda?.subjects && agenda?.subjects.length > 0
        ? `- Subtema: ${agenda.subjects
            ?.map(subjects => subjects.name)
            .join(', ')}`
        : ''
    }`
  }

  if (
    agenda.metadata &&
    agenda.font === 'projeto-x' &&
    agenda.type === 'primeiro-contato'
  ) {
    return `Primeiro Contato X ${
      agenda.metadata.field ? `- Área: ${agenda.metadata.field}` : ''
    } ${
      agenda?.themes && agenda?.themes?.length > 0
        ? `- Tema: ${agenda?.themes?.map(theme => theme.name).join(', ')}`
        : ''
    } ${
      agenda?.subjects && agenda?.subjects.length > 0
        ? `- Subtema: ${agenda.subjects
            ?.map(subjects => subjects.name)
            .join(', ')}`
        : ''
    }`
  }

  return ''
}
